import { getPathAncestry, } from '@sudoplatform-private/admin-web-utils';
import path from 'path-browserify';
import React, { useCallback, useEffect, useState } from 'react';
import { generatePath, Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Image } from '../../Image';
import { SudoPlatformLogo } from '../SudoPlatformLogo';
import { SidebarMenu } from './SidebarMenu';
const StyledSudoPlatformLogo = styled(SudoPlatformLogo) `
  padding: 20px 0;
`;
const StyledSidebar = styled.div `
  background-color: ${({ theme }) => theme.greys.midnight};
`;
const SidebarIcon = styled(Image) `
  display: inline-block;
  margin-right: 12px;
  max-height: 24px;
  max-width: 24px;
`;
const StyledLink = styled(Link) `
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Sidebar = ({ routes, projectId = 'NO_PROJECT', projectRootPath, }) => {
    const { pathname } = useLocation();
    const [openKeys, setOpenKeys] = useState(getPathAncestry(pathname));
    const generateMenuItems = (routes) => {
        return routes.map((route) => {
            const concretePath = getConcretePath(route.path);
            return {
                key: concretePath,
                label: (React.createElement(StyledLink, { to: concretePath },
                    route.iconPath && React.createElement(SidebarIcon, { imagePath: route.iconPath }),
                    route.displayName)),
                children: route.routes?.length ? generateMenuItems(route.routes) : null,
            };
        });
    };
    // Converts parameterized route paths to real paths, e.g.
    //   `/blah/foo/:projectId` => `/blah/foo/some-project`
    const getConcretePath = useCallback((routePath) => generatePath(path.join(projectRootPath, routePath), { projectId }), [projectId]);
    // Close all open menus when current path changes
    useEffect(() => setOpenKeys(getPathAncestry(pathname)), [pathname]);
    return (React.createElement(StyledSidebar, null,
        React.createElement(StyledSudoPlatformLogo, { lightLogo: true }),
        React.createElement(SidebarMenu, { mode: "inline", onOpenChange: setOpenKeys, selectedKeys: openKeys, openKeys: openKeys, items: generateMenuItems(routes) })));
};
